import { useState, useCallback } from "react";
import { IOption } from "components/shared/dropdown";
import { Maybe } from "true-myth";

export default function useDropdownOption<T>(
  initialVal: IOption<T> | (() => IOption<T>)
): [IOption<T>, (maybeOpt: Maybe<IOption<T>>) => void] {
  const [value, setValue] = useState<IOption<T>>(initialVal);
  const handleChange = useCallback(
    (maybeValue: Maybe<IOption<T>>) => {
      maybeValue.map((newValue) => {
        setValue(newValue);
        return true;
      });
    },
    [setValue]
  );
  return [value, handleChange];
}
